module.exports = __webpack_public_path__ + "static/media/Image 29@2x.e1202407.png";